import AreasAddForm from './AreasAddForm';

export default AreasAddForm;
